import React from 'react';
import { StyleProps } from '@summer/react-kit';
import { OptionFilter } from 'src/app/common/models/filter';
import { ConnectedCommonOptionFilter } from 'src/app/search/components/SearchPanel/CommonOptionFilter';

export const SearchEnginePerformanceFilter = (props: StyleProps) => (
  <ConnectedCommonOptionFilter
    columns={{ desktop: 2, mobile: 4 }}
    kind={OptionFilter.Engine}
    {...props}
  />
);
